import React from 'react';

import { useAuthStatus } from '@portal/utils';

import { NavigationUI } from './Navigation.ui';

export const UnifiedNavigationUI = () => {
  const { user, isAdmin, isSuperAdmin } = useAuthStatus();
  return <NavigationUI user={user} isAdmin={isAdmin} isSuperAdmin={isSuperAdmin} />;
};
